export default __webpack_public_path__ + "locales/zh.4511aad3243739306e051729a08eefc5.json";